module.exports = __webpack_public_path__ + "static/media/service2_card.e62ab02d.png";